import { UserRole } from '@data/enums/user-role.enum'

/**
 * Plazos de financiamiento permitidos (en meses).
 *
 * Regla de negocio (2026-07-01): Rendafin ofrece financiamiento única y
 * exclusivamente a 36, 48 y 60 meses. Esta es la source of truth única del
 * catálogo de plazos para AMBOS cotizadores (público `modules/public/quoter/`
 * y privado `modules/private/quote/`). Recortar/ampliar aquí, nunca duplicar
 * la lista en los servicios.
 *
 * Cotizaciones históricas con plazos ya retirados (12/14/18/24/72) se muestran
 * en modo edición como opciones deshabilitadas (ver `populateEditForm` +
 * `optionDisabled` en el template), pero no pueden elegirse de nuevo.
 */
export const ALLOWED_FINANCING_TERMS: readonly number[] = [36, 48, 60]

/**
 * Regla de negocio (2026-10-14): 12 y 24 meses se ofrecen única y exclusivamente
 * al rol Admin en el cotizador del panel. Para cualquier otro rol siguen siendo
 * plazos retirados: se ven al editar, deshabilitados, pero no se eligen.
 */
export const ADMIN_ONLY_FINANCING_TERMS: readonly number[] = [12, 24]

/** Opciones para el `p-multiSelect` de plazos (shape `{ label, value }`). */
export const FINANCING_TERM_OPTIONS: { label: string; value: number; disabled?: boolean }[] = ALLOWED_FINANCING_TERMS.map((m) => ({ label: `${m}`, value: m }))

/** Las opciones de plazo que puede elegir quien cotiza según su rol. */
export function financingTermOptionsFor(roleName: string | null | undefined): { label: string; value: number; disabled?: boolean }[] {
  const terms = roleName === UserRole.ADMIN ? [...ADMIN_ONLY_FINANCING_TERMS, ...ALLOWED_FINANCING_TERMS] : ALLOWED_FINANCING_TERMS
  return terms.map((m) => ({ label: `${m}`, value: m }))
}
